import { Device } from '@capacitor/device'

let k = localStorage.getItem("deviceID")
if (!k) {
    k = Math.random().toString(36).substr(2, 15)
    localStorage.setItem("deviceID", k)
}
export const deviceID = k

/**
 * Supports all platforms but is async
 */
export const deviceIDNative = Device.getId().then(id => id.identifier)